import { useCallback, useEffect, useState } from 'react'
import { useEditorContext } from '@/scenes/engine'
import Icons from '../../Icons'
import { customAmplitude } from '@/utils/customAmplitude'
import { useTranslation } from 'react-i18next'
import ContextMenuPanel, { ContextMenuPanelAction } from '../../ContextMenu/ContextMenuPanel'

function EditPageMenu({close, source, showHotkeys = true, numberOfSelected = 1}: {close: Function, source: 'top' | 'page', showHotkeys?: boolean, numberOfSelected?: number}) {
  const editor = useEditorContext().editor
  const [totalSence, setTotalSence] = useState(0)
  const isMac = navigator.userAgent.indexOf('Mac OS X') !== -1
  const { t } = useTranslation()

  useEffect(() => {
    customAmplitude('Multipage Click')
  }, [])

  const disabledDelete = totalSence <= 1
  const disabledPaste = !editor.handlers.pagesHandler.sceneClipboard || editor.handlers.pagesHandler.sceneClipboard.length === 0

  const MENU_ACTIONS: ContextMenuPanelAction[] = [
    {
      id: 'add',
      title: t('Add new page'),
      icon: Icons.NewPageIcon,
      enhancer: showHotkeys ? '' : undefined,
      onClick: async () => {
        await editor.handlers.pagesHandler.addNewScene()
        close()
      },
    },
    {
      id: 'copy',
      title: t('Copy'),
      icon: Icons.CopyIcon,
      enhancer: showHotkeys ? (isMac ? '⌘ C' : 'Ctrl+C') : undefined,
      onClick: async () => {
        await editor.handlers.pagesHandler.copyScene()
        close()
      },
    },
    {
      id: 'paste',
      title: t('Paste'),
      icon: Icons.PasteIcon,
      enhancer: showHotkeys ? (isMac ? '⌘ V' : 'Ctrl+V') : undefined,
      disabled: disabledPaste,
      onClick: async () => {
        await editor.handlers.pagesHandler.pasteScene()
        close()
      },
    },
    {
      id: 'duplicate',
      title: numberOfSelected > 1 ? `${t('Duplicate')} ${numberOfSelected} ${'pages'}` : t('Duplicate page'),
      icon: Icons.Duplicate,
      enhancer: showHotkeys ? (isMac ? '⌘ D' : 'Ctrl+D') : undefined,
      onClick: async () => {
        await editor.handlers.pagesHandler.duplicateScene()
        close()
      },
    },
    {
      id: 'delete',
      title: numberOfSelected > 1 ? `${t('Delete')} ${numberOfSelected} ${'pages'}` : t('Delete page'),
      icon: Icons.Delete,
      enhancer: showHotkeys ? 'DEL' : undefined,
      disabled: disabledDelete,
      onClick: () => {
        editor.handlers.pagesHandler.deleteScene()
        close()
      },
    },
  ]

  const refreshScenes = useCallback(() => {
    setTotalSence(editor.handlers.pagesHandler.scenes.length)
  }, [editor])
  useEffect(() => {
    if (!editor) return
    refreshScenes()

    editor.on('scenes:changed', refreshScenes)

    return () => {
      if (editor) {
        editor.off('scenes:changed', refreshScenes)
      }
    }
  }, [editor, refreshScenes])

  return <ContextMenuPanel items={MENU_ACTIONS} style={{ height: '248px', justifyContent: 'space-between' }} />
}

export default EditPageMenu
